import { getCookie } from '@/shared/utils/cookie';

const LOG_PREFIX = '[posthog-theme]';

export const isDebugModeEnabled = (): boolean => {
  return !!getCookie('debug_tracking');
};

export const posthogLog = (...args: Parameters<typeof console.log>): void => {
  if (isDebugModeEnabled()) {
    console.log(LOG_PREFIX, ...args);
  }
};
